import { END_POINT } from "../../constants/api.constants";

// Send the same OTP to the given email + phone (anonymous quote request).
export const sendOtpAPI = async (payload) => {
  return await fetch(END_POINT.SEND_OTP, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => ({
      status: data.status,
      message: data.message,
      data: data.data,
    }))
    .catch((error) => ({
      status: false,
      message: "Could not send the verification code. Please try again.",
      error,
    }));
};

// Verify a previously sent OTP.
export const verifyOtpAPI = async (payload) => {
  return await fetch(END_POINT.VERIFY_OTP, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => ({
      status: data.status,
      message: data.message,
      data: data.data,
    }))
    .catch((error) => ({
      status: false,
      message: "Could not verify the code. Please try again.",
      error,
    }));
};
